// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filters-content[data-v-68cafebe]{max-width:900px}ol[data-v-68cafebe],ul[data-v-68cafebe]{padding-left:20px}", ""]);
// Exports
module.exports = exports;
